export { default as VoyageScrollIndicator } from "./VoyageScrollIndicator"
